import { pathFor, type PageId } from '@nexa/content';
import type { jsonld } from '@nexa/seo';
import { useCopy, useLocale } from '@/core/i18n';

type BreadcrumbItem = Parameters<typeof jsonld.breadcrumbList>[1][number];

/**
 * Dựng đường dẫn phân cấp `Trang chủ › <Trang>` cho JSON-LD BreadcrumbList.
 *
 * Site này phẳng (mọi trang là con trực tiếp của trang chủ) nên breadcrumb chỉ có hai mắt.
 * Tách thành hook để khi thêm tầng (ví dụ `/vi/blog/<bai-viet>`) chỉ phải sửa ở đây, không
 * phải sửa từng trang.
 */
export function useBreadcrumb(pageId: PageId): readonly BreadcrumbItem[] {
  const locale = useLocale();
  const copy = useCopy();

  const home: BreadcrumbItem = { name: copy.nav.home, path: pathFor('home', locale) };
  if (pageId === 'home') return [home];

  // Tên mắt breadcrumb lấy từ `copy.page[pageId].heading`, KHÔNG phải `copy.nav[pageId]`.
  //
  // `copy.nav` chỉ chứa nhãn của thanh nav (6 anchor trong trang + vài nhãn điều khiển), nó
  // KHÔNG phủ mọi `PageId`. Dòng này trước đây biên dịch được chỉ vì `PageId` có đúng một giá
  // trị `'home'`: sau nhánh `if` ở trên, `pageId` hẹp về `never`, nên `copy.nav[never]` hợp lệ
  // một cách rỗng. Thêm `PageId` thứ hai là lộ ra ngay — tức đây là mã CHẾT đã lọt cổng kiểu.
  //
  // `copy.page` thì được `types.ts::CoverageCheck` ép phủ ĐỦ mọi `PageId`, nên nó là nguồn đúng
  // cho tên trang, và không thể thiếu khoá mà vẫn xanh.
  return [home, { name: copy.page[pageId].heading, path: pathFor(pageId, locale) }];
}
